import {
  ADMIN_DETAIL,
  CHANGE_PASSWORD_ROUTE,
  DRIVER_ROUTE,
  FORM_DRIVER_REGISTER,
  RIDER_REPORT,
} from '../paths';

export const HR_PERMISSION_ROUTE: string[] = [
  FORM_DRIVER_REGISTER,
  DRIVER_ROUTE,
  RIDER_REPORT,
  ADMIN_DETAIL,
  CHANGE_PASSWORD_ROUTE,
];
